import React from 'react';
import { AnimatePresence, motion } from 'framer-motion';
import { Check, Clock, Receipt, KeyRound, Ban } from 'lucide-react';
import { useStepCycle } from '../../hooks/useStepCycle';
import { EASE_OUT } from '../../utils/motion';
const modules = ['Benutzer & Rollen', 'Auftragsübersicht', 'Lagerbestand'];
export function InvoiceIllustration() {
  const step = useStepCycle(modules.length + 2, 1200);
  const approved = Math.min(step, modules.length);
  return <div className="absolute inset-0 p-6 xl:p-8 flex flex-col gap-4" data-id="element-62" data-mp="20ockn0f32z8j">
      <div className="flex-1 grid grid-cols-2 gap-4 min-h-0" data-id="element-63" data-mp="24odcpnv3v8y2">
        <div className="bg-white rounded-2xl shadow-sm p-4 flex flex-col" data-id="element-64" data-mp="29meu84cvv07f">
          <p className="text-sm font-semibold text-primary mb-3" data-id="element-65" data-mp="2em17uewmiigr">Review</p>
          <ul className="flex flex-col gap-2" data-id="element-66" data-mp="2enc8w6yopc46">
            {modules.map((m, i) => {
            const ok = i < approved;
            return <li key={m} className="flex items-center justify-between gap-2 rounded-lg bg-bg-alt px-3 py-2.5" data-id="element-67" data-mp="3q0ogmsxkeevm" data-mpi={i}>
                  <span className="text-xs xl:text-sm font-medium text-primary truncate" data-id="element-68" data-mp="31j0uk8mueljw">
                    {m}
                  </span>
                  <span className={`shrink-0 flex items-center gap-1 text-[10px] xl:text-[11px] font-semibold px-2 py-0.5 rounded-full transition-colors duration-200 ${ok ? 'bg-accent text-primary' : 'bg-white text-text-secondary'}`} data-id="element-69" data-mp="2sjvwt4j3uw8s">
                    {ok ? <Check className="w-3 h-3" strokeWidth={3} data-id="element-70" data-mp="2dtohuysb3vcu" /> : <Clock className="w-3 h-3" data-id="element-71" data-mp="29s37bk38vt5t" />}
                    {ok ? 'Abgenommen' : 'Offen'}
                  </span>
                </li>;
          })}
          </ul>
        </div>

        <div className="bg-white rounded-2xl shadow-sm p-4 flex flex-col" data-id="element-72" data-mp="1uwwy6o8ure89">
          <p className="text-sm font-semibold text-primary flex items-center gap-2 mb-3" data-id="element-73" data-mp="1uyzyq27mspr8">
            <Receipt className="w-4 h-4" data-id="element-74" data-mp="1l7zu3qegf5at" />
            Rechnung
          </p>
          <div className="flex flex-col gap-2 flex-1" data-id="element-75" data-mp="1q971hocoq2gy">
            <AnimatePresence initial={false} data-id="element-76" data-mp="1c8mkmxqbygq3">
              {modules.slice(0, approved).map(m => <motion.div key={m} initial={{
              opacity: 0,
              y: -6
            }} animate={{
              opacity: 1,
              y: 0
            }} exit={{
              opacity: 0,
              transition: {
                duration: 0.15
              }
            }} transition={{
              duration: 0.25,
              ease: EASE_OUT
            }} className="flex items-center justify-between gap-2 border-b border-dashed border-gray-200 pb-2" data-id="element-77" data-mp="1g9y8oytk2tw6">
                  <span className="text-xs text-text-secondary truncate" data-id="element-78" data-mp="1z8ao32b29007">{m}</span>
                  <span className="h-2 w-10 rounded-full bg-primary/20 shrink-0" data-id="element-79" data-mp="2my4xf9w686fp" />
                </motion.div>)}
            </AnimatePresence>
            {approved === 0 && <p className="text-xs text-text-secondary leading-snug" data-id="element-80" data-mp="ga4m5p75vtz1">
                Noch nichts abgenommen – noch nichts zu zahlen.
              </p>}
          </div>
          <div className="mt-auto pt-3 border-t border-gray-100 flex items-baseline justify-between gap-2" data-id="element-81" data-mp="b9gsevrjsz14">
            <span className="text-xs text-text-secondary" data-id="element-82" data-mp="l14eeh5c5nv7">Sie zahlen</span>
            <span className="text-sm font-bold text-primary" data-id="element-83" data-mp="l37g3yfup5fr">
              {approved} von {modules.length} Modulen
            </span>
          </div>
        </div>
      </div>

      <div className="grid grid-cols-2 gap-4" data-id="element-84" data-mp="3oj4p442a07ci">
        <div className="bg-primary text-white rounded-2xl px-4 py-3 flex items-center gap-3" data-id="element-85" data-mp="79ptu5vs5em1">
          <KeyRound className="w-6 h-6 text-accent shrink-0" data-id="element-86" data-mp="2amrwub3joia" />
          <div className="min-w-0" data-id="element-87" data-mp="291yj80iqbm0">
            <p className="font-bold leading-tight" data-id="element-88" data-mp="1iov0fkz17xax">100 % Ihr Code</p>
            <p className="text-xs text-white/70 truncate" data-id="element-89" data-mp="1in1uy905nj4i">Software & Quellcode gehören Ihnen</p>
          </div>
        </div>
        <div className="bg-primary text-white rounded-2xl px-4 py-3 flex items-center gap-3" data-id="element-90" data-mp="3je2b34kv6per">
          <Ban className="w-6 h-6 text-accent shrink-0" data-id="element-91" data-mp="3jgf2s9gfce50" />
          <div className="min-w-0" data-id="element-92" data-mp="3odyg975asmvw">
            <p className="font-bold leading-tight" data-id="element-93" data-mp="3of0286nuqtse">0 € Lizenzkosten</p>
            <p className="text-xs text-white/70 truncate" data-id="element-94" data-mp="3sd7ase85wosi">Keine laufenden Gebühren</p>
          </div>
        </div>
      </div>
    </div>;
}